import type { QuotaQueryKeyFactory } from "./types";

const BASE_QUOTA_QUERY_KEY = "quota";

const EXCEL_QUOTA_QUERY_KEY = "excel";
const COMPANY_IMFORMATION_QUOTA_QUERY_KEY = "company-information";
const CONTACTS_QUOTA_QUERY_KEY = "contacts";
const DATA_CREDITS_QUERY_KEY = "data-credits";
const COST_QUERY_KEY = "cost";
const APPS_QUERY_KEY = "apps";
const LEADS_QUERY_KEY = "leads";
const CONTACTS_QUERY_KEY = "contacts";
const COSTS_QUERY_KEY = "costs";
const CRM_ENRICHMENT_QUOTA_QUERY_KEY = "crm-enrichment";

export const quotaQueryKeys = {
    baseQuota() {
        return [BASE_QUOTA_QUERY_KEY] as const;
    },

    excelQuota() {
        return [BASE_QUOTA_QUERY_KEY, EXCEL_QUOTA_QUERY_KEY] as const;
    },

    companyInformationQuota() {
        return [BASE_QUOTA_QUERY_KEY, COMPANY_IMFORMATION_QUOTA_QUERY_KEY] as const;
    },

    contactsQuota() {
        return [BASE_QUOTA_QUERY_KEY, CONTACTS_QUOTA_QUERY_KEY] as const;
    },

    dataCredits() {
        return [BASE_QUOTA_QUERY_KEY, DATA_CREDITS_QUERY_KEY] as const;
    },

    dataCreditsContactsCost() {
        return [BASE_QUOTA_QUERY_KEY, DATA_CREDITS_QUERY_KEY, CONTACTS_QUOTA_QUERY_KEY, COST_QUERY_KEY] as const;
    },

    appsDataCredits() {
        return [BASE_QUOTA_QUERY_KEY, DATA_CREDITS_QUERY_KEY, APPS_QUERY_KEY] as const;
    },

    leadsDataCreditCosts() {
        return [BASE_QUOTA_QUERY_KEY, DATA_CREDITS_QUERY_KEY, LEADS_QUERY_KEY, COSTS_QUERY_KEY] as const;
    },

    contactsDataCredits() {
        return [BASE_QUOTA_QUERY_KEY, DATA_CREDITS_QUERY_KEY, CONTACTS_QUERY_KEY] as const;
    },

    crmEnrichmentQuota() {
        return [BASE_QUOTA_QUERY_KEY, CRM_ENRICHMENT_QUOTA_QUERY_KEY] as const;
    },
} satisfies QuotaQueryKeyFactory;
